<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-[9999] flex items-end justify-center" @click.self="$emit('close')">
      <div class="absolute inset-0 bg-black/40 backdrop-blur-sm" @click="$emit('close')" />

      <div class="relative w-full max-w-[430px] bg-cream rounded-t-2xl px-5 pt-5 pb-sheet-10 animate-slide-up" style="font-family: Inter, sans-serif;">
        <div class="flex items-center justify-between mb-1">
          <span class="text-18 font-semibold text-ink">В чём считать</span>
          <button @click="$emit('close')" class="w-8 h-8 flex items-center justify-center rounded-full text-ink active:bg-line transition-colors">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>
        <p class="text-14 text-ink/70 mb-5 truncate">{{ title }}</p>

        <!-- Граммы -->
        <button class="row" :class="{ on: !unit }" @click="pick(null)">
          <span class="text-15 font-semibold text-ink">Граммы</span>
          <span class="text-13 text-ink/70">как обычно</span>
        </button>

        <!-- Штуки: размеры из набора BUILTIN_UNITS (utils/units.js). Своих порций
             для любого продукта больше нет — решение владельца 26.10.2026 -->
        <template v-if="builtin">
          <p class="text-12 font-semibold text-ink/70 uppercase tracking-wide mt-4 mb-2 ml-1">{{ builtin.label }}, {{ builtin.unit === 'шт' ? 'штуки' : builtin.unit }}</p>
          <button v-for="s in builtin.sizes" :key="s.code" class="row" :class="{ on: unit?.kind === 'builtin' && unit.sizeCode === s.code }" @click="pickSize(s)">
            <span class="text-15 font-semibold text-ink">{{ s.label }}</span>
            <span class="text-13 text-ink/70">1 {{ builtin.unit }} ≈ {{ fmt(s.grams) }} г</span>
          </button>
          <p v-if="builtin.sizes.length > 1" class="text-12 text-ink/60 mt-2 ml-1">Выбранный размер запомнится для этого продукта.</p>
        </template>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { useUnitsStore } from '../store/units.js'
import { BUILTIN_UNITS } from '../utils/units.js'

// Шторка «в чём считать» для одной позиции: граммы или штуки выбранного
// размера. Ничего не считает сама — возвращает единицу (или null для граммов)
// наверх; размер пишет через store/units.js, чтобы он действовал во всех окнах.
const props = defineProps({
  title: { type: String, default: '' },
  productId: { type: Number, default: null },
  unit: { type: Object, default: null },        // текущая единица позиции или null
  builtinKey: { type: String, default: null },  // ключ из BUILTIN_UNITS или null
  weightG: { type: Number, default: 0 },
})
const emit = defineEmits(['select', 'close'])

const units = useUnitsStore()
const builtin = computed(() => props.builtinKey ? BUILTIN_UNITS[props.builtinKey] : null)
const fmt = (v) => Number.isInteger(Number(v)) ? String(v) : String(Math.round(Number(v) * 10) / 10).replace('.', ',')

function pick(u) { emit('select', u); emit('close') }

async function pickSize(s) {
  if (builtin.value.sizes.length > 1) {
    try {
      await units.setBuiltinSize(props.builtinKey, s.code, s.grams, builtin.value.unit)
    } catch { /* размер применится к этой записи и без сохранения */ }
  }
  pick({ name: builtin.value.unit, grams: s.grams, kind: 'builtin', key: props.builtinKey, sizeCode: s.code })
}
</script>

<style scoped>
.row { width: 100%; display: flex; align-items: center; justify-content: space-between; gap: 12px; background: #fff; border-radius: 14px; padding: 12px 14px; margin-bottom: 8px; border: 1px solid var(--line); text-align: left; }
.row.on { border-color: var(--ink); }
</style>
